import { render, staticRenderFns } from "./UserDashboard.vue?vue&type=template&id=33e376e0&"
import script from "./UserDashboard.vue?vue&type=script&lang=ts&"
export * from "./UserDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports